import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleTypeAdminComponent } from './components/article-type-admin/article-type-admin.component';
import { ArticleTypeAttributeListComponent } from './components/article-type-attribute-list/article-type-attribute-list.component';
import { ArticleTypeCalculationRuleListComponent } from './components/article-type-calculation-rule-list/article-type-calculation-rule-list.component';
import { ArticleTypeBaseArticleDefinitionListComponent } from './components/article-type-base-article-definition-list/article-type-base-article-definition-list.component';
import { ArticleTypeMasterdataComponent } from './components/article-type-masterdata/article-type-masterdata.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ArticleTypeRoutingModule } from './article-type-routing.module';
import { CommonTranslationModule, CommonUIModule, DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';

import { CommonLayoutModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { ArticleTypeAttributeEditorComponent } from './components/article-type-attribute-editor/article-type-attribute-editor.component';
import { ArticleTypeCalculationRuleEditorComponent } from './components/article-type-calculation-rule-editor/article-type-calculation-rule-editor.component';
import { ArticleTypeBaseArticleDefinitionEditorComponent } from './components/article-type-base-article-definition-editor/article-type-base-article-definition-editor.component';
import { ErpCommonModule } from '../erp-common/erp-common.module';
import { ArticleTypeAttributeGroupEditorComponent } from './components/article-type-attribute-group-editor/article-type-attribute-group-editor.component';
import { ArticleCommonModule } from '../common/article-common.module';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    ArticleTypeAdminComponent,
    ArticleTypeAttributeListComponent,
    ArticleTypeCalculationRuleListComponent,
    ArticleTypeBaseArticleDefinitionListComponent,
    ArticleTypeMasterdataComponent,
    ArticleTypeAttributeEditorComponent,
    ArticleTypeCalculationRuleEditorComponent,
    ArticleTypeBaseArticleDefinitionEditorComponent,
    ArticleTypeAttributeGroupEditorComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIModule,
    CommonTranslationModule,

    ReactiveFormsModule,
    ArticleTypeRoutingModule,
    DictionaryModule,
    ErpCommonModule,
    ArticleCommonModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule
  ],
  exports: [
    ArticleTypeAdminComponent
  ]
})
export class ArticleTypeModule { }
